// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8724) return "static/chunks/8724-fb2d48a93e3d15af.js";
	if (chunkId === 2931) return "static/chunks/2931-d94aad6134dbff90.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1230":"f8bae501dad76b45","2461":"9b9ff4873c9442a2","4423":"18ec95ce1ed00934","5172":"80d80839c41694f8","5961":"3a183eb4d034353e","7009":"2c81ff19f865e8ec","7610":"7e131ab40331726d","9714":"34e61432ab0b2eff"}[chunkId] + ".js";
};